import { patch } from "@/shared/axios";
import { errorToast } from "@/shared/utils/helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import useAccountQuery from "./useAccountQuery";
import useBranchId from "./useBranchId";

const useAccountHook = () => {
  const branch = useBranchId();
  const queryClient = useQueryClient();

  const { t } = useTranslation("");
  const query = useAccountQuery();
  const updateLanguage = useMutation<
    unknown,
    unknown,
    { itemId: number; language: number }
  >({
    mutationFn: ({ itemId, language }) =>
      patch(`internal/secure/pos/v1/cms/account/language/${branch}/${itemId}`, {
        language,
      }),
    onSuccess: async () => {
      toast.success(t("success.success"));
      queryClient.invalidateQueries({ queryKey: ["account", branch] });
    },
    onError: async () => {
      errorToast();
    },
  });

  return { query, updateLanguage };
};

export default useAccountHook;
